import { Logger } from '@quickplay/foundation';
import { DaiStreamManagerBuilder } from '../DaiStreamManagerBuilder';
import { createDaiStreamManager } from './DaiStreamManager';
import { DaiStreamManager } from '../models/DaiStreamManager';
import { MediaType } from '@quickplay/player-interface';

export function createDaiStreamManagerBuilder(): DaiStreamManagerBuilder {
  let imaSDK_: any;
  let videoElement_: HTMLVideoElement;
  let adElement_: Element;
  let locale_: string;
  let adTagParams_: any;
  let contentSourceId_: string;
  let videoId_: string;
  let assetKey_: string;
  let fallbackUrl_: string;
  let format_: MediaType;
  let apiKey_: string;
  let configuredLogger_: Logger;

  return {
    get imaSDK(): any {
      return imaSDK_;
    },

    get videoElement(): HTMLVideoElement {
      return videoElement_;
    },

    get adElement(): Element {
      return adElement_;
    },

    get locale(): string {
      return locale_;
    },

    get adTagParams(): any {
      return adTagParams_;
    },

    get contentSourceId(): string {
      return contentSourceId_;
    },

    get videoId(): string {
      return videoId_;
    },

    get fallback(): string {
      return fallbackUrl_;
    },

    get assetKey(): string {
      return assetKey_;
    },

    get format(): MediaType {
      return format_;
    },

    get apiKey(): string {
      return apiKey_;
    },

    get configuredLogger(): Logger {
      return configuredLogger_;
    },

    ima(ima: any): DaiStreamManagerBuilder {
      imaSDK_ = ima;
      return this;
    },

    contentContainerElement(element: Element): DaiStreamManagerBuilder {
      adElement_ = element;
      return this;
    },

    contentVideoElement(element: HTMLVideoElement): DaiStreamManagerBuilder {
      videoElement_ = element;
      return this;
    },

    localization(locale: string): DaiStreamManagerBuilder {
      locale_ = locale;
      return this;
    },

    adTagParameters(params: any): DaiStreamManagerBuilder {
      adTagParams_ = params;
      return this;
    },

    contentSource(id: string): DaiStreamManagerBuilder {
      contentSourceId_ = id;
      return this;
    },

    video(id: string): DaiStreamManagerBuilder {
      videoId_ = id;
      return this;
    },

    fallbackUrl(url: string): DaiStreamManagerBuilder {
      fallbackUrl_ = url;
      return this;
    },

    asset(code: string): DaiStreamManagerBuilder {
      assetKey_ = code;
      return this;
    },

    mediaType(type: MediaType): DaiStreamManagerBuilder {
      format_ = type;
      return this;
    },

    apiToken(token: string): DaiStreamManagerBuilder {
      apiKey_ = token;
      return this;
    },

    logger(logger: Logger): DaiStreamManagerBuilder {
      configuredLogger_ = logger;
      return this;
    },

    build(): DaiStreamManager {
      return createDaiStreamManager(this);
    },
  };
}
